import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'Overview',
    //     icon: 'bx-home-circle',
    //     link: 'admin',
    // },
    {
        id: 2,
        label: 'Overview',
        icon: 'bx bxs-copy-alt',
        link: 'eligibility/eligibilityCheck',
    },
    {
        id: 3,
        label: 'Onboarding',
        icon: 'bx bx-customize',
        subItems: [
            {
                id: 31,
                label: 'Integration Work Flow',
                link: 'eligibility/eligibilityCheck',
                parentId: 5
            },
            {
                id: 32,
                label: 'Vehicle Consent Process',
                subItems: [
                    {
                        id: 321,
                        label: 'Fordpro',
                        link: 'eligibility/eligibilityCheck',
                        parentId: 32
                    },
                    {
                        id: 322,
                        label: 'GM',
                        link: 'eligibility/eligibilityStatus',
                        parentId: 32
                    },
                    {
                        id: 523,
                        label: 'Stellantis',
                        link: 'eligibility/eligibilityStatus',
                        parentId: 32
                    },
                    {
                        id: 524,
                        label: 'Toyota',
                        link: 'eligibility/eligibilityStatus',
                        parentId: 32
                    },
                ]
            },
            {
                id: 53,
                label: 'Connectivity Matrix',
                link: 'eligibility/eligibilityStatus',
                parentId: 5
            },
        ]
    },
    {
        id: 4,
        label: 'Signal Map',
        icon: 'bx bx-user-circle',
        link: 'eligibility/eligibilityCheck',
      
    },
    {
        id: 5,
        label: 'Developer Corner',
        icon: 'bx-car',
        link: 'vinDecoder/vindecoder',
        subItems: [
            {
                id: 51,
                label: 'Document',
                link: 'eligibility/eligibilityCheck',
                parentId: 5
            },
            {
                id: 52,
                label: 'API',
                link: 'eligibility/eligibilityStatus',
                parentId: 5
            },
            {
                id: 53,
                label: 'Trip Simulator',
                link: 'eligibility/eligibilityStatus',
                parentId: 5
            },
        ]
    },
];

